import React from 'react';
import { hot } from 'react-hot-loader/root';
import _ from 'root/libs/exaforte/react/lodash';
import Config from 'root/globals/Config';
import { View, Text, Image } from 'react-native';
import { Container } from 'root/globals/Elements';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faCalendarStar, faClipboardListCheck, faCheck } from '@fortawesome/pro-light-svg-icons';

import defaults from 'root/globals/Defaults.less';
import view from './ActivationSuccesView.less';

const styles = {...defaults, ...view};

const Possibilities = [
    {icon: faCalendarCheck, color: 'orange', description: 'Je kan je rooster inzien via de app!'},
    {icon: faCalendarStar, color: 'mint-blue', description: 'Vraag je vrije dagen aan!'},
    {icon: faClipboardListCheck, color: 'blue', description: 'En accordeer je diensten!'}
];

export default hot(class ActivationSuccesView extends React.Component {
    constructor(props) {
        super(props);

        this.environment_id     = (window.location.host.includes('secure-it') ? 1 : 2);
        this.environment_name   = (this.environment_id == 1 ? 'Secure-IT' : 'Facil-IT');
    }

    _renderPossibility(possibility, index) {
        return (
            <View className={['col-12 col-md-4 mb-5 mb-md-0']} key={index}>
                <View className={['d-flex flex-column align-items-center']}>
                    <View className={['rounded-circle mb-4', styles['center-children'], styles['background-color-' + possibility.color + '-10'], styles['possibility-circle']]}>
                        <FontAwesomeIcon icon={possibility.icon} className={[styles['color-' + possibility.color], styles['f-10-5']].join(' ')} />
                    </View>
                    <Text className={['text-center', styles['f-2-5'], styles['line-height-3-5'], styles['font-roboto']]}>{possibility.description}</Text>
                </View>
            </View>
        );
    }
    
    render() {
        return (
            <Container>
                <View className={[styles['container'], styles['background-color-white'], styles['border-top-color-light-blue']]}>
                    <Text className={['mb-3 font-weight-bold', styles['f-6'], styles['line-height-6'], styles['font-roboto']]}>Hi {this.props.user.firstname}, welkom bij {this.environment_name}!</Text>
                    <Text className={['mb-5', styles['f-2-5'], styles['line-height-3-5'], styles['font-roboto']]}><b>Je account is succesvol geactiveerd!</b> Hieronder vind je alle voordelen die je vanaf nu kan gebruiken! Je hoeft alleen nog maar de app te <b>downloaden</b>.</Text>
                    <View className={['d-flex flex-row align-items-start p-4 p-md-5 mb-5', styles['background-color-light-blue-10'], styles['font-roboto']]}>
                        <FontAwesomeIcon icon={faCheck} className={['d-none d-sm-block mr-2', styles['color-light-blue'], styles['f-9']].join(' ')} />
                        <View className={['px-md-3']}>
                            <Text className={['font-weight-bold mb-2 mb-md-0', styles['f-3-7-5']]}>De laatste stap!</Text>
                            <View className={['row']}>
                                <View className={['col-12 col-xl-9']}>
                                    <Text className={[styles['f-2-5']]}>Download de <b>{this.environment_name} app</b> uit de <a className={[styles['color-light-blue'], styles['text-underline']].join(' ')} href={this.environment_id == 1 ? 'https://play.google.com/store/apps/details?id=com.exaforte.secureit&gl=NL' : 'https://play.google.com/store/apps/details?id=com.exaforte.facilit&gl=NL'} target="_blank">Play store</a> of <a className={[styles['color-light-blue'], styles['text-underline']].join(' ')} href={this.environment_id == 1 ? 'https://apps.apple.com/nl/app/secure-it/id965776758' : 'https://apps.apple.com/nl/app/facil-it/id6450011491'} target="_blank">App store</a> en log in om je rooster in te kunnen zien en je diensten te kunnen accorderen.</Text>
                                </View>
                            </View>
                            <View className={['d-flex flex-column flex-sm-row mt-3']}>
                                <a className={['mb-3 mb-sm-0 mr-sm-3']} href={this.environment_id == 1 ? 'https://play.google.com/store/apps/details?id=com.exaforte.secureit&gl=NL' : 'https://play.google.com/store/apps/details?id=com.exaforte.facilit&gl=NL'} target="_blank">
                                    <Image className={[styles['play-store-badge']]} source={Config.GLOBAL_IMAGES_URL + 'google-play-badge.png'} native={true} />
                                </a>
                                <a href={this.environment_id == 1 ? 'https://apps.apple.com/nl/app/secure-it/id965776758' : 'https://apps.apple.com/nl/app/facil-it/id6450011491'} target="_blank">
                                    <Image className={[styles['app-store-badge']]} source={Config.GLOBAL_IMAGES_URL + 'app-store-badge.png'} native={true} />
                                </a>
                            </View>
                        </View>
                    </View>
                    <Text className={['pt-4 mb-4 pb-3 font-weight-bold', styles['f-3-7-5'], styles['font-roboto']]}>Wat je kan doen met {this.environment_name}</Text>
                    <View className={['row mb-md-5 pb-md-5']}>{_.map(Possibilities, this._renderPossibility)}</View>
                    <Text className={['pt-5 mb-1 font-weight-bold', styles['f-3-7-5'], styles['font-roboto']]}>Wil je meer weten over {this.environment_name}?</Text>
                    <Text className={[styles['f-2-5'], styles['font-roboto']]}>Op onze website zijn alle onderwerpen nog een voor je op een rijtje gezet. We leggen ze stap voor stap voor je uit. Bekijk ze <a className={[styles['color-blue']]} href={'https://www.' + this.environment_name.toLowerCase() + '.nl/'} target="_blank">hier!</a></Text>
                </View>
            </Container>
        );
    }
})